module.exports = __webpack_public_path__ + "static/media/second.65ab2ce5.jpg";